/* THIS FILE IS GENERATED ON RUNTIME. DO NOT EDIT */

import { ComponentClassNameFactory } from 'lib/contexts/ComponentClassNameFactory';
import getPropStylesFactory from 'lib/utils/getPropStylesFactory';
import getComponentStylesFactory from 'lib/utils/getComponentStylesFactory';
import getComponentThemeFactory from 'lib/utils/getComponentThemeFactory';
import make_styler from '../index';

export const styles = {
  "link": {
    "variant_default": "no-underline block",
    "colors_default": "text-black",
    "size_default": "w-full ml-6 md:ml-0"
  },
  "image": {
    "variant_default": "data-[fill]:aspect-square not-prose relative block object-cover",
    "colors_default": "bg-transparent",
    "size_default": "w-full"
  },
  "caption_variant_default": "",
  "caption_colors_default": "text-black",
  "caption_size_default": "text-al-body-lg",
  "variant_default": "text-center",
  "colors_default": "",
  "size_default": ""
};

const c = make_styler(styles);

export const propClassName = getPropStylesFactory(c, styles, "SliderSlide");

export const componentClassName = getComponentStylesFactory(propClassName);

export const componentTheme = getComponentThemeFactory(styles);

export const {
  ClassNameContext,
  ClassNameProvider,
  useClassName,
  useTheme,
} = ComponentClassNameFactory(componentClassName, styles);
  
export default c;